package amazon.lastmile.inject

import app.nestbridge.feature.invitations.ui.ShowInvitationQRCodeUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ShowInvitationQRCodeUiFactory::class)
public interface AppNestbridgeFeatureInvitationsUiShowInvitationQRCodeUiFactory {
  @Provides
  @IntoSet
  public fun provideShowInvitationQRCodeUiFactoryFactoryMultibinding(showInvitationQRCodeUiFactory: ShowInvitationQRCodeUiFactory): Ui.Factory = showInvitationQRCodeUiFactory
}
